<template>
    <b-modal title="Project" no-close-on-backdrop hide-footer size="lg" v-model="largeModal" @ok="largeModal = false">
        <form @submit.prevent="updateProject">
            <div class="container custom_modal_body">
                <div class="form-group row">
                    <label for="inputPassword3" class="col-sm-2 col-form-label">Category</label>
                    <div class="col-sm-4">
                        <div class="input-group">
                            <select v-validate="'required'"  name="Category" v-model="editProject.project_category_id"  class="form-control" >
                                <option value="" >Select Category</option>
                                <option v-if="category.status == 1 " v-for="(category,index) in project_categories" :key="index" :value="category.id">{{category.name}}</option>
                            </select>
                            <span v-if="project_categories.length <= 0" style="background: #e0ebeb;padding-left:10px;padding-right:10px;" class="input-group-addon">
                                <i style="margin-top:10px;" class="fa fa-refresh fa-spin"></i>
                            </span>
                        </div>
                        <p  v-show="errors.has('Category')" style="color:red">* {{ errors.first('Category') }}</p>
                    </div>
                    <label for="dayameter_type" class="col-sm-2 col-form-label">Diameter Type</label>
                    <div class="col-sm-4">
                        <input name="dayameter_type" v-validate="'required'" v-model="editProject.dayameter_type" type="text" step="0.1" class="form-control"  placeholder="Dayameter Type">
                        <p  v-show="errors.has('dayameter_type')" style="color:red">* {{ errors.first('dayameter_type') }}</p>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="name" class="col-sm-2 col-form-label">Service Name</label>
                    <div class="col-sm-4">
                        <input name="name" v-validate="'required'" v-model="editProject.name" type="text" class="form-control" id="name" placeholder="Service Name">
                        <p  v-show="errors.has('name')" style="color:red">* {{ errors.first('name') }}</p>
                    </div>

                    <label for="inputPassword3" class="col-sm-2 col-form-label">Family Member</label>
                    <div class="col-sm-4">
                        <input name="family_member" v-validate="'required'" v-model="editProject.family_member" type="text" step="0.1" class="form-control"  placeholder="Family Member">
                        <p  v-show="errors.has('family_member')" style="color:red">* {{ errors.first('family_member') }}</p>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="price" class="col-sm-2 col-form-label">Price</label>
                    <div class="col-sm-4">
                        <input name="price" v-validate="'required'" v-model="editProject.price" type="text" class="form-control" id="price" placeholder="Price">
                        <p  v-show="errors.has('price')" style="color:red">* {{ errors.first('price') }}</p>
                    </div>

                    <label for="connection_fee" class="col-sm-2 col-form-label">Connection Fee</label>
                    <div class="col-sm-4">
                        <input name="connection_fee" v-validate="'required'" v-model="editProject.connection_fee" type="text" step="0.1" class="form-control"  placeholder="Connection Fee">
                        <p  v-show="errors.has('connection_fee')" style="color:red">* {{ errors.first('connection_fee') }}</p>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="update_fee" class="col-sm-2 col-form-label">Update Fee</label>
                    <div class="col-sm-4">
                        <input name="update_fee" v-validate="'required'" v-model="editProject.update_fee" type="text" step="0.1" class="form-control"  placeholder="Update Fee">
                        <p  v-show="errors.has('update_fee')" style="color:red">* {{ errors.first('update_fee') }}</p>
                    </div>
                    <label for="inputPassword3" class="col-sm-2 col-form-label">Type <span class="required">*</span></label>
                    <div class="col-sm-4">
                        <div class="input-group">
                            <select v-validate="'required'"  name="Category" v-model="editProject.type"  class="form-control" >
                                <option value="" >Select Type</option>
                                <option value="1">আবাসিক</option>
                                <option value="2">বাণিজ্যিক</option>
                                <option value="3">বাণিজ্যিক (অফিস)</option>
                            </select>
                        </div>
                        <p  v-show="errors.has('Category')" style="color:red">* {{ errors.first('Category') }}</p>
                    </div>
                </div>

            </div>
            <div class="form-group row">
                <div class="col-sm-12">
                <input v-if="!addLoader" type="submit" value="Submit" class="btn btn-primary pull-right"/>
                <button v-if="addLoader" class="btn btn-primary pull-right" type="button" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Submitting...
                </button>
                <button v-if="!addLoader"  @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                </div>
            </div>
        </form>
    </b-modal>
</template>

<script>
import { UPDATE_PROJECT,DELETE_PROJECT,All_PROJECT_CATEGORY} from "../../store/action.type"
import { mapState,mapGetters } from "vuex"
export default {
    data(){
        return{
            largeModal:false,
            addLoader:false,
            index:'',
            url:null,
            editProject:{
                name:'',
                status:null,
                project_id:'',
                project_category_id:'',
                dayameter_type:'',
                connection_fee:'',
                family_member:'',
                update_fee:'',
                price:'',
                type:''
            }
        }
    },
    methods:{
        close(){
            this.largeModal = false
        },
        openModal(project,index){
            this.largeModal = true
            this.index = index
            this.editProject.name = project.name
            this.editProject.dayameter_type = project.diameter
            this.editProject.status = project.status
            this.editProject.project_id = project.id
            this.editProject.project_category_id = project.project_category_id
            this.editProject.connection_fee = project.connection_fee
            this.editProject.family_member = project.family_member
            this.editProject.update_fee = project.update_fee
            this.editProject.type = project.type
            this.editProject.price = project.price
        },
        updateProject(){
            this.addLoader = true;
            var data = this.editProject
            var index = this.index
            this.$store.dispatch('UPDATE_PROJECT',{data,index})
            .then(response=>{
                this.addLoader = false;
                this.largeModal = false
                this.$iziToast.success({position:'topRight',title:'Ok',message:"Service Updated Successsfully"})

            })
            .catch(error=>{
                this.addLoader = false;
                this.$iziToast.error({position:'topRight',title:'Error',message:"Something Wrong !!"})
            });
        },
        allCategory(){
            this.$store.dispatch('All_PROJECT_CATEGORY')
        },
        imageChanged(e) {
            // console.log(e.target.files[0])
            var fileReader = new FileReader()
            fileReader.readAsDataURL(e.target.files[0])
            fileReader.onload = (e) => {
                this.editProject.image = e.target.result
                this.editProject.not_edit_image = 11
            }
            this.url = URL.createObjectURL(e.target.files[0])

        }

    },
    mounted(){
        this.allCategory()
    },
    computed:{
        ...mapGetters(["project_categories"]),

    }
}
</script>

<style>

</style>
